import { createElement } from '../utils/dom.js';
import { iconMapPin, iconPackage } from '../utils/icons.js';
import { renderArticleItem } from './article-item.js';

/**
 * Rend une section de rayon avec ses articles.
 * @param {{ id: number, name: string, order: number }|null} aisle - null pour "Sans rayon"
 * @param {Array} items
 * @param {{ onToggle: Function, onDelete: Function, onQuantityChange: Function }} callbacks
 * @returns {HTMLElement}
 */
export function renderAisleSection(aisle, items, callbacks) {
  const section = createElement('section', { className: 'aisle-section' });

  const isUncategorized = aisle === null;
  const iconEl = isUncategorized ? iconPackage(18) : iconMapPin(18);
  const title = isUncategorized ? 'Sans rayon' : aisle.name;

  const header = createElement('div', {
    className: 'aisle-section__header',
    children: [
      createElement('span', { className: 'aisle-section__icon', children: [iconEl] }),
      createElement('h3', { className: 'aisle-section__title', text: title }),
      createElement('span', {
        className: 'badge badge--muted aisle-section__count',
        text: String(items.length),
      }),
    ],
  });

  const itemsContainer = createElement('div', { className: 'aisle-section__items' });

  if (items.length === 0) {
    itemsContainer.appendChild(createElement('p', {
      className: 'text-muted text-center',
      attrs: { style: 'padding: var(--space-md)' },
      text: 'Aucun article',
    }));
  } else {
    for (const item of items) {
      itemsContainer.appendChild(renderArticleItem(item, callbacks));
    }
  }

  section.append(header, itemsContainer);
  return section;
}
